module.exports = __webpack_public_path__ + "static/media/em_construcao.fe1339ab.png";